import moment from "moment";
import numeral from "numeral";
import merge from "lodash/merge";
// Dates & Times
export const DISPLAY_DATE_FORMAT = "MM/DD/YYYY";
export const LONG_DISPLAY_DATE_FORMAT = "MMMM D, YYYY";
export const PARSED_DATE_FORMAT = "YYYYMMDD";
export const PARSED_DATE_FORMAT_NEW = "YYYY-MM-DD";

export const DISPLAY_TIME_FORMAT = "h:mm A";
export const PARSED_TIME_FORMAT = "HH:mm:ss z";

export const convertDateToParsedDateString = (date: any) =>
    date.format(PARSED_DATE_FORMAT_NEW);

export const convertNewParsedDateStringToDate = (date: string) =>
    moment(date, PARSED_DATE_FORMAT_NEW);

export const convertDisplayDateToParsedDateString = (date: string) =>
    moment(date, DISPLAY_DATE_FORMAT).format(PARSED_DATE_FORMAT_NEW);

export const convertParsedDateStringToDisplayDateString = (date: string) =>
    moment(date, PARSED_DATE_FORMAT_NEW).format(DISPLAY_DATE_FORMAT);

export const convertParsedDateStringToLongDisplayDateString = (date: string) =>
    moment(date, PARSED_DATE_FORMAT_NEW).format(LONG_DISPLAY_DATE_FORMAT);

export const convertParsedTimeToDisplayTimeString = (date: string) =>
    moment(date, PARSED_TIME_FORMAT).format(DISPLAY_TIME_FORMAT);

export const thirtyDaysAgoParam = () =>
    moment()
        .add(-30, "days")
        .format(PARSED_DATE_FORMAT_NEW);

// Numbers
export const formatMoney = (value: string, format: string = "($0,0)") =>
    numeral(value).format(format);

export const parseMoney = (value: string) => numeral(value);

// Addresses
export const formatAddress = (address: Address) =>
    `${address.addr1}, ${address.city}, ${address.stateProvCd} ${address.postalCode}`;

export const nestedObjectValueFromKey = (nestedObject: Object, key: string) => {
    return key.split(".").reduce((object: any, prop: string) => {
        return object && object[prop];
    }, nestedObject);
};
// payment page coverage section population
export const nestedObjectValueFromKeyParsed = (nestedObject: Object, key: string) => {

    const parsedKey = (key !== "" && key.indexOf("lines") !== -1) ? key
            .replace("uMBILimit", "umbiLimit")
            .replace("bILimit", "biLimit")
            .replace("pDLimit", "pdLimit")
        : key;
    return parsedKey.split(".").reduce((object: any, prop: string) => {
        return object && object[prop];
    }, nestedObject);
};

export const lowerFirstLetter = (str: string): string =>
    str.charAt(0).toLowerCase() + str.slice(1);

export const addMoneyFloatStrings = (a: string, b: string) => {
    return (
        parseFloat(a.replace(/[$,]/g, "") || "0.00") +
        parseFloat(b.replace(/[$,]/g, "") || "0.00")
    );
};

/*
added to search index for the
   select values in the coverage for auto
*/
export const searchIndex = (description: any,
                            tagDescription: any,
                            line: Lines) => {
    if (description === "bodilyInjury") {
        return line.biLimit;
    } else if (description === "propertyDamage") {
        return line.pdLimit;
    } else if (description === "medPay") {
        return line.medPayLimit;
    } else if (description === "umBodilyInjury") {
        return line.umbiLimit;
    } else if (description === "comprehensiveDeductible") {
        return line!.risks![0].vehicle!.comprehensiveDed;
    } else if (description === "collisionDeductible") {
        return line!.risks![0].vehicle!.collisionDed;
    } else if (tagDescription === "Waiver of Collision Deductible") {
        return line!.risks![0].vehicle!.liabilityWaiveInd! ? "Yes" : "No";
    } else if (tagDescription === " Underinsured Motorist Bodily Injury") {
        return "";
    } else if (tagDescription === "Rental Reimbursement") {
        return line!.risks![0].vehicle!.rentalReimbursementInd! ? "Yes" : "No";

    } else if (tagDescription === "Towing And Labor") {
        return line!.risks![0].vehicle!.towingAndLaborInd! ? "Yes" : "No";
    }
    return "0";
};

export const openBlobInNewTab = (blob: Blob) => {
    const newBlob = new Blob([blob], {type: "application/pdf"});
    const data = window.URL.createObjectURL(newBlob);
    window.open(data);
};

/*
* code for ensuring the risk values before
* updating are updated with there respective data types and object level
* */
export function mergeUpdatedCoverage(values: any) {
    var mergedAp = null;
    if (values!.lines !== undefined) {
        const parsedLines =
            {
                lines: values!.lines!.map(
                    (datap: ParseLineConstants) => {
                        return {
                            biLimit: datap!.biLimit,
                            pdLimit: datap!.pdLimit,
                            umbiLimit: datap!.umbiLimit,
                            umpdwcdInd: datap!.umpdwcdInd !== undefined ? (datap!.umpdwcdInd === "Yes") : undefined,
                            medPayLimit: datap!.medPayLimit,
                            risks: mergeRisks(datap)
                        }
                    }
                )
            };
        mergedAp = merge(values, parsedLines);
    } else {
        mergedAp = values;
    }
    return mergedAp;
}

/*
* common function for lines and risk coverage updated
* */
export function mergeRisks(values: any) {
    return values!.risks! ? values!.risks!.map((risk: ParseRisk) => {
        return {
            vehicle:
                {
                    liabilityWaiveInd: risk!.vehicle!.liabilityWaiveInd !== undefined ?
                        (risk!.vehicle!.liabilityWaiveInd === "Yes" ? true : false) : undefined,
                    collisionDed: risk!.vehicle!.collisionDed,
                    comprehensiveDed: risk!.vehicle!.comprehensiveDed,
                    rentalReimbursementInd: undefined !== risk!.vehicle!.rentalReimbursementInd ? (
                        risk!.vehicle!.rentalReimbursementInd === "Yes" || true === risk!.vehicle!.rentalReimbursementInd ? true : false
                    ) : undefined,
                    towingAndLaborInd: undefined !== risk!.vehicle!.towingAndLaborInd ?
                        ("Yes" === risk!.vehicle!.towingAndLaborInd || true === risk!.vehicle!.towingAndLaborInd ? true : false) : undefined,
                    statedAmtInd: undefined !== risk!.vehicle!.statedAmtInd ?
                        ("Yes" === risk!.vehicle!.statedAmtInd || true === risk!.vehicle!.statedAmtInd ? true : false) : undefined
                }
        }
    }) : []

}